import { TEAM } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export const Team = () => (
  <section
    id="team"
    data-testid="team-section"
    className="relative bg-cream px-6 py-28 md:px-12 md:py-40"
  >
    <div className="mx-auto max-w-[1200px]">
      <Reveal>
        <div className="mb-16 md:mb-20">
          <p className="mb-6 text-[0.7rem] uppercase tracking-[0.3em] text-sage">
            The People
          </p>
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-ink sm:text-5xl md:text-6xl">
            Who are <span className="italic text-forest">we?</span>
          </h2>
        </div>
      </Reveal>

      <div className="grid gap-12 md:grid-cols-2 md:gap-16">
        {TEAM.map((m, i) => (
          <Reveal key={m.name} delay={i * 0.1}>
            <div data-testid={`team-${m.id}`}>
              <span className="text-[0.7rem] uppercase tracking-[0.25em] text-sage">
                {m.role}
              </span>
              <h3 className="mt-2 font-serif text-3xl tracking-tight text-forest md:text-4xl">
                {m.name}
                <span className="mt-1 block font-sans text-xs font-light tracking-wide text-sage md:text-sm">
                  {m.creds}
                </span>
              </h3>
              <span className="mt-3 inline-block rounded-full border border-forest/30 px-4 py-1 text-xs tracking-wide text-forest">
                {m.sees}
              </span>
              <p className="mt-5 text-base font-light leading-relaxed text-stone">
                {m.bio}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
